import React from 'react';
import {Container, Row, Col, Card, CardBody, Form, Button, Label, Input, FormGroup, CustomInput} from 'reactstrap';
import notificaiton from './../../helpers/notificationHelper';
import { SPOKEN_LANGUAG_ARRAY } from './../../inc/constants';
import 'react-widgets/dist/css/react-widgets.css';

export default class EditFAQ extends React.Component{
    state = {
        title : '',
        description : '',
        isFetching : false,
        language : '',
        faq_id :'',
        isActive : false
    }

    static getDerivedStateFromProps(props, state){
        //console.log('meeting props', props.meeting);
        if(props.meeting && !props.meeting.isFetching && props.meeting.isFetching !== state.isFetching){
            return {
                isFetching : false
            }
        }
        return null;
    }

    componentDidMount(){

        //console.log('props in didmount', this.props);
        let { search } = this.props.location; 
        let searchKeys =  new URLSearchParams(search);
        let faqId = searchKeys.get('faqid');
        if(!faqId){
            this.props.history.push('/faq');
        }
        //console.log('faqid', faqId);
        this.props._fetchDetails(faqId);

    }

    componentDidUpdate(prevProps, prevStates){
        // console.clear();
        //console.log('props', this.props);
        let { FAQDetails, updateFAQ } = this.props;
        if(FAQDetails !== prevProps.FAQDetails){
            if( FAQDetails.isFetched && !FAQDetails.err && !FAQDetails.isFetching){
                let { _id, title, description, language, isActive } = FAQDetails.data
                return this.setState({
                    title,
                    description,
                    language,
                    faq_id : _id,
                    isActive
                })
            }
        }
        //console.log('updateFAQ', updateFAQ)
        if(updateFAQ !== prevProps.updateFAQ){
            if( updateFAQ.isFetched && !updateFAQ.err && !updateFAQ.isFetching){
                notificaiton('success', updateFAQ.message);
                return this.props.history.push('/faq');
            }else if( !updateFAQ.isFetched && updateFAQ.err && !updateFAQ.isFetching){
                return notificaiton('error', updateFAQ.message);
                // return this.props.history.push('/meetings');
            }
        }
    }
    
    onChangeHandler = (e) => {
        // console.log('name', e.checked)
        // console.log('value', e.target.value);
        let { name, value } = e.target;
        if(name === 'isActive') value = !this.state.isActive 
        let data = {
            [name] : value
        }
        // console.log('name', name)
        // console.log('value', value);
        return this.setState(data)
    }

    onSubmitHandler = (e) => {
        //console.log("submitted");
        e.preventDefault();
        let { faq_id, title, description, language, isActive  } = this.state;
        if(!title || !description || !language) return notificaiton('error', 'All Fields are mandatory !')
        let data = {
            title,
            description,
            language,
            faq_id,
            isActive
        }
        return this.props._onEdit(data);
    }

    render(){
        let { title, description, language, isActive } = this.state;
        let { updateFAQ : { isFetching } } = this.props;
        return(
            <Container  >
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardBody className="bg-white ">
                                <h3 className='page-title bb-1 border-gray mb-4'>Edit FAQ</h3>
                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Form onSubmit ={this.onSubmitHandler}>
                                            <Row form className="mb-3">
                                                <Col md={12} sm={12}>
                                                    <Label className="text-muted">Title:</Label>
                                                    <Input type="text" name="title" value={title} 
                                                        onChange={ this.onChangeHandler } required 
                                                        placeholder = "Enter Title" disabled={isFetching}
                                                    />
                                                </Col>
                                                
                                            </Row>
                                            
                                            <Row className="text-right mb-2">
                                                <Col md={12}  sm={12}>
                                                <Input type="textarea" name="description" value ={description}
                                                        onChange={ this.onChangeHandler } required
                                                        placeholder = "Enter Description" disabled={isFetching}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mb-2"> 
                                                <Col md={4} sm={12}>
                                                    {/* <Label htmlFor="typeselect">Language For :- </Label> */}
                                                    <Input type="select" name="language" id="typeselect" value={language} defaultValue="" onChange={this.onChangeHandler}>
                                                        <option value="" >Select Language</option>
                                                        {SPOKEN_LANGUAG_ARRAY && SPOKEN_LANGUAG_ARRAY.length > 0 && (
                                                            SPOKEN_LANGUAG_ARRAY.map((lang) => {
                                                                return (
                                                                    <option key={lang.value} value={lang.value}>{lang.name}</option>
                                                                )
                                                            })
                                                        )}
                                                    </Input>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4} sm={12} >
                                                    <FormGroup row>
                                                        <Label htmlFor="isActive" sm={4}>isActive</Label>
                                                        <Col sm={8}>
                                                            <CustomInput type="switch" name="isActive" id={'faq'} onClick={this.onChangeHandler } checked={ isActive } />
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row className="text-right mt-2">
                                                <Col md={12}  sm={12}>
                                                    {isFetching ? (
                                                        <Button color="default" disabled>Save...</Button>
                                                    ) : (
                                                        <Button color="primary" type="submit">Save</Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}